import { useEffect, useState } from "react";
import { Download, Trash2, Mail } from "lucide-react";
import { Button } from "../ui/button";
import api, { downloadFile } from "../../lib/api";
import { toast } from "sonner";
import NewsletterCompose from "./NewsletterCompose";

export default function NewsletterPanel() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/newsletter/subscribers").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const remove = async (email) => {
    if (!window.confirm(`Rimuovere ${email}?`)) return;
    await api.delete(`/newsletter/subscribers/${encodeURIComponent(email)}`);
    toast.success("Iscritto rimosso");
    load();
  };
  return (
    <div className="space-y-6">
    <NewsletterCompose subscribers={rows.length} />
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="newsletter-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h3 className="font-serif text-xl font-semibold text-[#0B2A45] flex items-center gap-2"><Mail className="w-5 h-5" />Iscritti newsletter <span className="text-sm text-stone-400 font-sans">({rows.length})</span></h3>
        <Button variant="outline" className="rounded-full" onClick={() => downloadFile("/newsletter/subscribers.xlsx", "newsletter_iscritti.xlsx")} data-testid="newsletter-export-btn"><Download className="w-4 h-4 mr-2" />Esporta Excel</Button>
      </div>
      {rows.length === 0 ? <p className="text-sm text-stone-400" data-testid="newsletter-empty">Nessun iscritto ancora.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-stone-500 border-b"><th className="py-2 pr-4">Email</th><th className="py-2 pr-4">Origine</th><th className="py-2 pr-4">Iscritto il</th><th /></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.email} className="border-b border-stone-100" data-testid={`newsletter-row-${r.email}`}>
                  <td className="py-2 pr-4 font-medium text-[#0B2A45]">{r.email}</td>
                  <td className="py-2 pr-4 text-stone-500">{r.source}</td>
                  <td className="py-2 pr-4 text-stone-500">{(r.created_at || "").slice(0, 10)}</td>
                  <td className="py-2 text-right"><button onClick={() => remove(r.email)} className="text-stone-400 hover:text-red-600" data-testid={`newsletter-delete-${r.email}`}><Trash2 className="w-4 h-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
    </div>
  );
}
